import PortalIdParser from 'PortalIdParser';
import { useQuery } from 'data-fetching-client';
import { GET_USER_INFO } from 'pricing-pages-api/user/queries';
import { useCallback } from 'react';
import { logApiError, logApiSuccess } from '../../utils/apiLogging';
const DIRECTORY_USER = 'partner-join-program';
const PARTNER_LEAD_REGISTRATION = 'partner-lead-registration';
export const useIsInAppAuth = () => {
  const isInApp = !!PortalIdParser.get();
  return isInApp;
};
export const useUserInfo = () => {
  var _userInfoQuery$data;
  const isAppAuth = useIsInAppAuth();
  const handleCompleted = useCallback(() => {
    logApiSuccess({
      queryName: 'GET_USER_INFO',
      operation: 'getUserInfo'
    });
  }, []);
  const handleError = useCallback(error => {
    logApiError(error, {
      queryName: 'GET_USER_INFO',
      operation: 'getUserInfo'
    });
  }, []);
  const userInfoQuery = useQuery(GET_USER_INFO, {
    skip: !isAppAuth,
    onCompleted: handleCompleted,
    onError: handleError
  });
  return {
    userInfo: (_userInfoQuery$data = userInfoQuery.data) === null || _userInfoQuery$data === void 0 ? void 0 : _userInfoQuery$data.userInfo,
    loading: userInfoQuery.loading,
    error: userInfoQuery.error
  };
};
export const useIsInternalHubspotUser = () => {
  var _userInfo$user;
  const {
    userInfo
  } = useUserInfo();
  return (userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 || (_userInfo$user = _userInfo$user.email) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.endsWith('@hubspot.com')) || false;
};
export const usePortalGates = () => {
  const {
    userInfo
  } = useUserInfo();
  return (userInfo === null || userInfo === void 0 ? void 0 : userInfo.gates) || [];
};
export const useIsSeatsUser = () => {
  var _userInfo$user2;
  const {
    userInfo
  } = useUserInfo();
  const isAppAuth = useIsInAppAuth();
  return isAppAuth ? (userInfo === null || userInfo === void 0 || (_userInfo$user2 = userInfo.user) === null || _userInfo$user2 === void 0 || (_userInfo$user2 = _userInfo$user2.scopes) === null || _userInfo$user2 === void 0 ? void 0 : _userInfo$user2.includes('seats-access')) || false : true;
};
export const useIsDeveloperPortal = () => {
  var _userInfo$user3;
  const {
    userInfo
  } = useUserInfo();
  const scopes = new Set((userInfo === null || userInfo === void 0 || (_userInfo$user3 = userInfo.user) === null || _userInfo$user3 === void 0 ? void 0 : _userInfo$user3.scopes) || []);
  const hasUnifiedDevPlatformAccess = scopes.has('unified-dev-platform-access');
  const hasFullCrmAccess = scopes.has('full-crm-access');
  const hasDeveloperPortalAccess = scopes.has('developer-portal-access');

  // https://hubspot.slack.com/archives/C08G8T21THQ/p1755523947388609
  return !hasUnifiedDevPlatformAccess && !hasFullCrmAccess && hasDeveloperPortalAccess;
};
export const useIsPartnerProgramEligible = () => {
  var _userInfo$user4;
  const {
    userInfo
  } = useUserInfo();
  const scopes = userInfo === null || userInfo === void 0 || (_userInfo$user4 = userInfo.user) === null || _userInfo$user4 === void 0 ? void 0 : _userInfo$user4.scopes;
  const isDirectoryUser = scopes === null || scopes === void 0 ? void 0 : scopes.some(scope => scope === DIRECTORY_USER);
  const isPartner = scopes === null || scopes === void 0 ? void 0 : scopes.some(scope => scope === PARTNER_LEAD_REGISTRATION);
  return Boolean(isDirectoryUser && !isPartner);
};